import { makeStyles } from '@material-ui/core/styles';
import { AuthGuard, ErrorMessage, Page } from 'components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import useErrorCatcher from 'utils/useErrorCatcher';
import useFilter from 'utils/useFilter';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  error: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const ListComp = props => {
  let { params, listing, filters = { limit: 10, offset: 0, count: 0 }, name, title, searchable, roles = [], projects = [], SearchBar, Header, Results, CreateComp, Filter, comp_props = {} } = props;

  const classes = useStyles();

  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, updateFilter, listenFilters] = useFilter(name, { ...filters });
  const [errorMessage, setErrorMessage] = useState(null);
  const [openCreate, setOpenCreate] = useState(false);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  const handleCreateOpen = () => {
    setOpenCreate(true);
  }

  const handleCreateClose = () => {
    setOpenCreate(false);
  }

  const reload = async () => {
    setLoading(true);
    await runAsyncBlock(async () => {
      const { models, meta } = params ? await listing(params, { query: filter }) : await listing({ query: filter });
      if (mounted) {
        updateFilter(meta);
        setModels(models);
      }
    }).finally(() => { mounted && setLoading(false) });
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...listenFilters]);

  useEffect(() => {
    mounted = true;
    reload();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFilter = (query) => {
    updateFilter(query);
  };

  const handleSearch = (search) => {
    updateFilter({ search, offset: 0 });
  };

  return (
    <AuthGuard roles={roles} projects={projects}>
      <Page className={classes.root} title={title}>
        {Header && <Header handleCreateOpen={handleCreateOpen} />}
        <ErrorMessage className={classes.error} message={errorMessage} variant="card" />
        {searchable && SearchBar && <SearchBar onSearch={handleSearch} onFilter={handleFilter} Filter={Filter} />}
        {Results && <Results className={classes.results} title={title} models={models} setModels={setModels} loading={loading} filter={filter} onPageChange={handleFilter} {...comp_props.results} />}
        {CreateComp && <CreateComp onClose={handleCreateClose} onCreate={reload} open={openCreate} {...comp_props.create_comp} />}
      </Page>
    </AuthGuard>
  );
}

ListComp.propTypes = {
  listing: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  searchable: PropTypes.bool,
  roles: PropTypes.array,
  projects: PropTypes.array,
  SearchBar: PropTypes.func,
  Header: PropTypes.func.isRequired,
  Results: PropTypes.func.isRequired,
  CreateComp: PropTypes.func
};

export default ListComp; 